import React from 'react';

const AddressField = ({ 
    field, 
    value, 
    error, 
    touched, 
    onChange,
    onBlur,  // ✅ Aggiunto onBlur
    options = null,
    disabled = false 
}) => {
    const { name, type, label, required, placeholder, hint, maxLength } = field;
    
    const hasError = touched && error;
    const inputId = `field-${name}`;
    
    const handleChange = (e) => {
        onChange(name, e.target.value);
    };
    
    const handleBlur = (e) => {
        if (onBlur) {
            onBlur(name, e.target.value);
        }
    };
    
    // Render select per province
    if (type === 'select' && options) {
        return (
            <div className={`form-group ${hasError ? 'has-error' : ''} address-selector`}>
                <label htmlFor={inputId}>
                    {label} {required && <span className="required">*</span>}
                </label>
                <select
                    id={inputId}
                    value={value || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={disabled}
                    className={hasError ? 'error' : ''}
                >
                    <option value="">Seleziona {label.toLowerCase()}</option>
                    {options.map(opt => (
                        <option key={opt.code} value={opt.code}>
                            {opt.name}
                        </option>
                    ))}
                </select>
                {hint && <small className="form-hint">{hint}</small>}
                {hasError && <span className="error-message">{error}</span>}
            </div>
        );
    }
    
    // Render input standard
    return (
        <div className={`form-group ${hasError ? 'has-error' : ''}`}>
            <label htmlFor={inputId}>
                {label} {required && <span className="required">*</span>}
            </label>
            <input
                type={type}
                id={inputId}
                value={value || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={placeholder || ''}
                maxLength={maxLength}
                disabled={disabled}
                className={hasError ? 'error' : ''}
            />
            {hint && <small className="form-hint">{hint}</small>}
            {hasError && <span className="error-message">{error}</span>}
        </div>
    );
};

export default AddressField;
